<template>
  <ol
    class=""
    :class="
      cn(
        'flex w-full space-x-1.5 pb-3.5 font-light max-md:overflow-auto md:py-5',
        props.class,
      )
    "
    vocab="http://schema.org/"
    typeof="BreadcrumbList"
  >
    <li
      v-for="(item, idx) in generalStore.breadcrumbs"
      :key="item.text"
      class="inline-flex items-center space-x-1 text-xs max-md:whitespace-nowrap"
      :aria-current="item.disabled ? 'page' : undefined"
      property="itemListElement"
      typeof="ListItem"
    >
      <span v-if="idx !== 0" :class="[light ? 'text-white' : 'text-black']">
        /
      </span>
      <nuxt-link
        v-if="!item.disabled && item.href"
        :to="localePath(item.href)"
        property="item"
        class="underline-offset-4 hover:underline"
        :class="[light ? 'text-gray-30' : 'text-gray-60']"
        typeof="WebPage"
      >
        <span property="name">{{ item.text }}</span>
      </nuxt-link>
      <button
        v-else-if="!item.disabled && item.action"
        :class="[light ? 'text-gray-30' : 'text-gray-60']"
        @click="item.action"
      >
        <span property="name">{{ item.text }}</span>
      </button>
      <span
        v-else
        property="name"
        :class="[
          item.active ? 'font-medium' : '',
          light ? 'text-white' : 'text-black',
        ]"
      >
        {{ item.text }}
      </span>
      <meta property="position" :content="String(idx + 1)" />
    </li>
  </ol>
</template>

<script setup lang="ts">
import type { HTMLAttributes } from "vue";

const props = defineProps<{
  light?: boolean;
  class?: HTMLAttributes["class"];
}>();

const localePath = useLocalePathPolyfill();
const generalStore = useGeneralStore();
</script>
